import { startDate } from '../config/info'

export default {

  data() {
    return {
      processing: false,
      items: [],
      dateFromModal: false,
      dateToModal: false,
      monthModal: false,
      minDateFrom: startDate,
      minDateTo: startDate,
      maxDate: this.today('YYYY-MM-DD'),
      maxDateTo: this.today('YYYY-MM-DD'),
    }
  },

  computed: {

    headers () {
      return this.filter.period === 'monthly' && this.hasDateWiseReport ? 
        this.$options.dateWiseHeaders : this.$options.itemWiseHeaders
    },
    
    dateFromLabel () {
      return this.filter.period === 'daily' ? 'Date' : 'Date From'
    },

    hasDateTo () {
      return this.filter.period === 'weekly' || this.filter.period === 'custom'
    },

    isDateToEditable () {
      return this.filter.period === 'custom'
    },

    sheetName() {
      switch(this.filter.period) {
        case 'daily':
          return this.filter.date_from
        break
        case 'weekly': case 'custom':
          return `${this.filter.date_from} - ${this.filter.date_to}`
        break
        case 'monthly':
          return this.filter.year_month
        break
      }
    },

    resultTitle () {
      return `${this.filter.period} ${this.title}_${this.sheetName || ''}`
    },

  },

  created() {
    
    let breadcrumbs = [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/dashboard'
        },
        {
          text: 'Reports',
          disabled: true
        },
        {
          text: this.title,
          disabled: true
        }
      ]

    this.$store.commit('setBreadcrumbs', breadcrumbs)
    this.$store.commit('setPageTitle', this.title)

    this.$options.periods = [
      {
        type: 'daily',
        text: 'Daily'
      },
      {
        type: 'weekly',
        text: 'Weekly'
      },
      {
        type: 'monthly',
        text: 'Monthly'
      },
      {
        type: 'custom',
        text: 'Custom'
      }
    ]

  },

  watch: {
    
    'filter.period': function(val) {
      
      this.filter.date_from = ''
      this.filter.date_to = ''
      this.filter.year_month = ''
      this.items = []
      if(val === 'daily') {
        this.filter.date_from = this.today('YYYY-MM-DD')
      }
      if(val === 'weekly' || val === 'custom') {
        this.filter.date_from = this.$moment().subtract(6, 'days').format('YYYY-MM-DD')
        this.filter.date_to = this.today('YYYY-MM-DD')
      }
      if(val === 'weekly'){
        this.maxDate = this.$moment().subtract(6, 'days').format('YYYY-MM-DD')
      }
      else{
        this.maxDate = this.today('YYYY-MM-DD')
      }
      if(val === 'monthly') {
        this.filter.year_month = this.$moment().format('YYYY-MM')
      }

    },

    'filter.date_from': function(val) {
      this.filter.date_to = ''
      this.items = []
      if (val && this.hasDateTo) {
        this.filter.date_to = this.$moment(val, 'YYYY-MM-DD').add(6, 'days').format('YYYY-MM-DD')
        this.minDateTo = this.filter.date_from
      }
      if (val && this.filter.period === 'custom') {
        this.maxDateTo = this.today('YYYY-MM-DD')
        let from = this.$moment(val)
        let today = this.$moment()
        if (today.diff(from, 'days') > 60) {
          this.maxDateTo = this.$moment(val, 'YYYY-MM-DD').add(60, 'days').format('YYYY-MM-DD')
        }
      }
    },

    'filter.year_month': function(val) {
      this.items = []
    },

  },

  methods: {
    
    loadReport () {

      let api_path = this.reportsApiPath
      
      let filterArray = [ "type=inline" ]

      for (const [key, val] of Object.entries(this.filter)) {
        if (val) {
          filterArray.push(`${key}=${val}`)
        }
      }

      if (filterArray.length) {
        api_path += '?' + filterArray.join('&')
      }
      
      this.processing = true
      this.axios.get(api_path)
        .then((response) => {
          this.processing = false
          if (this.isSuccessResponse(response)) {
            this.items = response.data.data
          }
          else{
            this.items = []
          }
        })
        .catch((error) => {
          this.processing = false
        })
    },

  },

}
